import BaseController from 'src/lib/controller/base_controller';
import { dismissSingleToast } from 'src/lib/overlay/toast';

export default class ButtonToastDismiss extends BaseController {
  public handleButtonClick() {
    const toastId = this.getRequiredDataAttr('toastId');
    dismissSingleToast({ id: toastId });
  }
}
